import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '../../shared/guards/auth.guard';
import { NomOrgComponent } from './nom-org.component';
import { nomOrgPageGuard } from '../../shared/guards/role.guard';

const routes: Routes = [
  {
    path: 'nominating-organisations',
    component: NomOrgComponent,
    canActivate: [authGuard, nomOrgPageGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NomOrgsRoutingModule { }
